import React, { useCallback, useEffect, useState } from "react";
import useComponentVisible from "../../../../hooks/useComponentVisible";
import PersonalizedIcon from "../../../../shared/assets/customIcons/PersonalizedIcon";
import MountIcons from "../../../../shared/utils/MountIcons";
import IconSvg from "../../../editor/components/IconSvg";
import { animate, useAnimation, useMotionValue, motion } from "framer-motion";

import {
  BorderView,
  Button,
  LabelButton
} from "../../components/SearchBar/styles";

import {
  Container,
  Input,
  DropDownContainer,
  DropDownHeader,
  DropDownListContainer,
  DropDownList,
  VerticalStack,
  HorizontalStack,
  ListItem
} from "./styles";

interface QueryProps {
  search?: string;
  filter?: string;
}

interface SearchProps {
  onClickSearchButton?: () => void;
  value: string;
  label?: string;
  query?: QueryProps;
  setQuery?: React.Dispatch<React.SetStateAction<QueryProps>>;
  onChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
}

const category = [
  {
    name: "Favoritos",
    icon: "/images/icon-star-filter.svg",
    description: "ícone de favoritos",
    function: "favorite"
  },

  {
    name: "Todos",
    icon: "/images/icon-all-filter.svg",
    description: "ícone de favoritos",
    function: "all"
  }
];

const list = {
  visible: {
    opacity: 1,
    y: 5,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.3
    }
  },
  hidden: {
    opacity: 0,
    y: -20,
    transition: {
      when: "afterChildren"
    }
  }
};

const variants = {
  visible: (i: number) => ({
    opacity: 1,
    transition: {
      delay: i * 0.3
    }
  }),
  hidden: { opacity: 0 }
};

const SearchBar: React.FC<SearchProps> = ({
  onClickSearchButton,
  value,
  onChange,
  query,
  setQuery,
  label
}) => {
  const controls = useAnimation();
  const x = useMotionValue(0);

  useEffect(() => {
    const controls = animate(x, 100, {
      type: "spring",
      stiffness: 2000
    });

    return controls.stop;
  });

  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(true);

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  return (
    <Container>
      <BorderView>
        <PersonalizedIcon
          dPath={MountIcons.Zoom.dPath}
          viewBox={MountIcons.Zoom.viewBox}
          className="icon"
          width={27}
          height={27}
        />
        <Input type={"text"} value={value} onChange={onChange}></Input>
        {/* <PersonalizedIcon
          dPath={MountIcons.IconFilter.dPath}
          viewBox={MountIcons.IconFilter.viewBox}
          className="icon"
          width={30}
          height={30}
        /> */}

        <DropDownContainer ref={ref}>
          <DropDownHeader Open={isOpen} onClick={handleClick}></DropDownHeader>
        </DropDownContainer>
      </BorderView>
      <Button onClick={onClickSearchButton}>
        <LabelButton> {label} </LabelButton>
      </Button>
    </Container>
  );
};

export default SearchBar;
